// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"602":"25d03bd1","622":"c30991bb","732":"88f69b75","977":"87a2ea63"}[chunkId] + ".chunk.js";
};